export enum ServiceType {
  Delivery = "Delivery",
  Operation = "Operation"
}
